<template>
  <div
    v-if="$store.getters.isLoggedIn && contentItem.contentId"
    id="content-edit"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      width="250px"
      mobile-break-point="0"
      floating
      app>
      <div class="h-100 d-flex flex-column page-drawer">
        <!-- DelMar Logo -->
        <router-link
          id="logo"
          class="mx-auto my-5"
          to="/content">
          <img
            src="../assets/img/logo.png"
          />
        </router-link>
        <!-- / DelMar Logo -->

        <div class="page-navigation-container d-flex flex-column flex-grow-1">
          <!-- Main Navigation -->
          <MainNavigation />
          <!-- / Main Navigation -->

          <!-- Content Navigation -->
          <ContentNavigation />
          <!-- / Content Navigation -->
        </div>

        <!-- User Account Menu -->
        <UserMenu class="mt-auto" />
        <!-- User Account Menu -->
      </div>
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- Content Page Content -->
    <v-content class="h-100">
      <v-toolbar
        class="my-2 page-toolbar">
        <v-app-bar-nav-icon
          class="page-drawer-toggle"
          @click="isDrawerOpen = !isDrawerOpen">
        </v-app-bar-nav-icon>

        <v-toolbar-title
          class="pl-0">
          <h4 class="d-flex align-center">
            <router-link
              class="plain"
              to="/content/all">
              {{$store.state.user.projectName}}
            </router-link>
            <v-icon size="18px">mdi-chevron-double-right</v-icon>
            Edit
            {{contentItemInfo(contentItem.contentId).section}}
            {{contentItemInfo(contentItem.contentId).element}}
            <span class="ml-1">
              <span
                v-if="contentItemInfo(contentItem.contentId).dimensions.width">
                {{contentItemInfo(contentItem.contentId).dimensions.width}}w
              </span>
              <span
                v-if="contentItemInfo(contentItem.contentId).dimensions.width
                  && contentItemInfo(contentItem.contentId).dimensions.height">
                x
              </span>
              <span
                v-if="contentItemInfo(contentItem.contentId).dimensions.height">
                {{contentItemInfo(contentItem.contentId).dimensions.height}}h
              </span>
            </span>
          </h4>
        </v-toolbar-title>
      </v-toolbar>

      <v-divider class="mx-5"></v-divider>

      <div class="page-content p-0 mx-5 mb-5">
        <v-tabs
          class="page-tabs"
          background-color="transparent"
          v-model="tab"
          @change="tabChange">
          <v-tab>
            <v-icon class="mr-1">mdi-square-edit-outline</v-icon>
            Edit
          </v-tab>
          <v-tab>
            <v-icon class="mr-1">mdi-history</v-icon>
            Revisions
          </v-tab>
        </v-tabs>

        <ContentEditRichText
          v-if="contentItem.type === 'richText'"
          class="page-tabs-content"
          :tab="tabName"
        />

        <ContentEditText
          v-if="contentItem.type === 'text'
            && contentItemInfo(contentItem.contentId).section !== 'Colors'"
          class="page-tabs-content"
          :tab="tabName"
        />

        <ContentEditColor
          v-if="contentItem.type === 'text'
            && contentItemInfo(contentItem.contentId).section === 'Colors'"
          class="page-tabs-content"
          :tab="tabName"
        />

        <ContentEditImage
          v-if="contentItem.type === 'image'"
          class="page-tabs-content"
          :tab="tabName"
        />
      </div>
    </v-content>
    <!-- / Content Page Content -->
  </div>
</template>

<script>
import _ from 'lodash';
import MainNavigation from '../components/MainNavigation.vue';
import ContentNavigation from '../components/ContentNavigation.vue';
import UserMenu from '../components/UserMenu.vue';
import ContentEditRichText from '../components/ContentEditRichText.vue';
import ContentEditText from '../components/ContentEditText.vue';
import ContentEditColor from '../components/ContentEditColor.vue';
import ContentEditImage from '../components/ContentEditImage.vue';
import ContentItemMixin from '../mixin.content-item';

export default {
  name: 'ContentEdit',
  mixins: [
    ContentItemMixin,
  ],
  components: {
    MainNavigation,
    ContentNavigation,
    UserMenu,
    ContentEditRichText,
    ContentEditText,
    ContentEditColor,
    ContentEditImage,
  },
  data() {
    return {
      isDrawerOpen: true,
      tab: 0,
      tabs: ['edit', 'revisions'],
    };
  },
  watch: {
    $route(newRoute) {
      const { tab } = newRoute.params;
      if (tab) {
        this.tabName = tab;
      }
    },
  },
  computed: {
    tabName: {
      get() {
        return this.tabs[this.tab];
      },
      set(tabName) {
        this.tab = this.tabs.indexOf(tabName);
      },
    },
  },
  methods: {
    getRevisions() {
      this.$store.dispatch('getContentItemRevisions', this.$route.params.contentId);
    },
    tabChange() {
      const params = _.clone(this.$route.params);

      params.tab = this.tabName;
      this.$router.push({ name: 'ContentEdit', params });

      if (this.tabName === 'revisions') {
        this.getRevisions();
      }
    },
  },
  mounted() {
    this.tabName = this.$route.params.tab;
    if (this.tabName === 'revisions') {
      this.getRevisions();
    }
    this.$store.commit('setContentItemRevisions', []);
  },
};
</script>

<style lang="scss"></style>
